export const abbreviateUserDisplayName = (
    firstName: string,
    lastName: string,
    maxDisplayNameLength: number
): string => {
    const displayNameLength = firstName.length + lastName.length;
    let displayFirstName = firstName;
    let displayLastName = lastName;
    // abbreviate display name if it exceeds max length
    if (displayNameLength + 2 >= maxDisplayNameLength) {
        const abbreviationLength = Math.floor((maxDisplayNameLength - 2) / 2);
        displayLastName = lastName.length > abbreviationLength ? `${lastName.slice(0, abbreviationLength)}.` : lastName;
        displayFirstName =
            firstName.length > abbreviationLength ? `${firstName.slice(0, abbreviationLength)}.` : firstName;
    }
    return `${displayLastName}, ${displayFirstName}`;
};
